module.exports = __webpack_public_path__ + "img/flowIndexCircle.2202bebc.png";